import { ReviewQueue } from "@/components/ReviewQueue";

export default function TeacherPortal() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6" data-testid="teacher-portal">
      <div className="mb-8">
        <p className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">Expert</p>
        <h1 className="mt-1 font-heading text-3xl font-bold tracking-tight sm:text-4xl">Review & Correct</h1>
        <p className="mt-2 text-muted-foreground">Approve, reject or fix AI-generated and newly-ingested questions before students see them.</p>
      </div>
      <ReviewQueue />
    </div>
  );
}
